// @ts-nocheck
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Typography, TextField, InputAdornment, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { StringUtils } from '../../../../../common/utils';

const useStyles = makeStyles(theme => ({
  textField: {
    marginTop: theme.spacing(2),
    minHeight: '70px',
  },
}));

function OrderRefund(props) {
  const [error, setError] = useState(null);
  const [t] = useTranslation();
  const classes = useStyles();

  const { order, onChange, onError } = props;

  useEffect(() => {
    const hasError = _.isNil(error) || !_.isEmpty(error);
    onError(hasError);
  }, [error, onError]);

  const handleRefundAmountChange = event => {
    const { value } = event.target;
    const regex = /^[0-9]*[0-9][,][0-9]{2}(\sKr\.)?$/;

    const refundAmount = _.toNumber(value.replace(/[^0-9]/g, ''));
    const sum = refundAmount + _.toNumber(order.refund.refundedAmount);
    const rest = _.toNumber(order.order.sum) - order.refund.refundedAmount;

    if (!value) {
      setError(t('order.orderRefundAmountEmpty'));
    } else if (!regex.test(value)) {
      setError(t('order.orderRefundAmountDecimal'));
    } else if (refundAmount === 0) {
      setError(t('order.orderRefundAmountNonZero'));
    } else if (sum > order.order.sum) {
      setError(t('order.orderRefundAmountMoreThanSum', { sum: StringUtils.getFormattedSum(rest) }));
    } else {
      setError('');
    }

    onChange(value);
  };

  return (
    <Box id="OrderRefund-container">
      <Typography>{`${t('order.orderRefundPrice')}: ${StringUtils.getFormattedSum(
        order.order.sum
      )}`}</Typography>
      <Typography>{`${t('order.orderRefundedAmount')}: ${
        order.refund ? StringUtils.getFormattedSum(order.refund.refundedAmount) : '0,00 Kr.'
      }`}</Typography>
      <TextField
        id="OrderRefund-amount"
        label={t('order.orderRefundAmount')}
        placeholder="0,00 Kr."
        className={classes.textField}
        error={!_.isEmpty(error)}
        helperText={error}
        onChange={handleRefundAmountChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>local_atm</Icon>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}

OrderRefund.propTypes = {
  order: PropTypes.shape({
    order: PropTypes.shape({
      creationDate: PropTypes.string,
      duration: PropTypes.number,
      effectiveDate: PropTypes.string,
      executedAt: PropTypes.string,
      formerProductId: PropTypes.number,
      freePeriod: PropTypes.number,
      lastGrace: PropTypes.bool,
      orderId: PropTypes.number,
      orderLines: PropTypes.arrayOf(PropTypes.object),
      orderStatus: PropTypes.string,
      partnerAgreementId: PropTypes.number,
      partnerAssociateId: PropTypes.number,
      paymentInfo: PropTypes.shape({
        paymentOwner: PropTypes.string,
        paymentType: PropTypes.string,
        cardNo: PropTypes.string,
        cardCountry: PropTypes.string,
        cardUpdate: PropTypes.string,
        expireMonth: PropTypes.number,
        expireYear: PropTypes.number,
        pic: PropTypes.string,
        recurringId: PropTypes.string,
      }),
      product: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        price: PropTypes.number,
        discountDays: PropTypes.number,
        durationDays: PropTypes.number,
        commitmentDays: PropTypes.number,
        productGroup: PropTypes.string,
      }),
      provider: PropTypes.number,
      retryCount: PropTypes.number,
      status: PropTypes.string,
      sum: PropTypes.number,
      type: PropTypes.string,
      updateDate: PropTypes.string,
      userId: PropTypes.string,
      vastoken: PropTypes.string,
      voucher: PropTypes.string,
    }),
    paymentInfo: PropTypes.shape({
      recurringId: PropTypes.string,
      paymentType: PropTypes.string,
      cardUpdate: PropTypes.string,
      cardType: PropTypes.string,
      cardCountry: PropTypes.string,
      cardExpMonth: PropTypes.number,
      cardExpYear: PropTypes.number,
      cardMask: PropTypes.string,
      cardPrefix: PropTypes.string,
      pic: PropTypes.string,
    }),
    refund: PropTypes.shape({
      refundable: PropTypes.bool,
      refundedAmount: PropTypes.number,
    }),
    transactions: PropTypes.arrayOf(PropTypes.object),
    events: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default OrderRefund;
